import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Terms: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      console.log('Current user ID:', user.id);
    }
  }, [user]);

  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl">
      <h1 className="text-4xl font-bold mb-8">Terms and Conditions</h1>
      
      <div className="prose prose-lg">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing and using WhenBald, you agree to be bound by these Terms and Conditions. If you do not agree, please discontinue use of the service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Disclaimer of Liability</h2>
          <p>
            WhenBald provides AI-generated hair loss progression previews for informational purposes only. Results are not medical advice or guarantees. You should always consult a healthcare professional before making hair loss treatment decisions.
          </p>
          <p className="mt-4">We are not liable for:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Accuracy or outcome of hair loss progression images</li>
            <li>Service interruptions or unavailability</li>
            <li>Decisions or actions taken based on hair loss previews</li>
            <li>Any damages resulting from errors, omissions, or incomplete information</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Service Description</h2>
          <p>
            WhenBald allows users to upload a photo and receive a simulated hair loss progression preview based on genetic and environmental factors. All features are provided "as is" and may be modified, replaced, or discontinued at any time without notice.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Intellectual Property Rights</h2>
          <p>
            All content, technology, and branding on WhenBald are protected by intellectual property rights. Reproduction, distribution, or use of our images, code, or content in other publications without explicit permission is strictly prohibited.
          </p>
          <p className="mt-4">
            Any brand names or product references remain the property of their respective owners.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. External Links</h2>
          <p>
            WhenBald may include links to external websites. We are not responsible for the content, availability, or practices of linked sites, and do not endorse or accept liability for their content.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. User Responsibilities</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>Provide accurate and honest information</li>
            <li>Use the service for lawful and intended purposes</li>
            <li>Not attempt to reverse engineer, hack, or misuse the service</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Modifications to Terms</h2>
          <p>
            We reserve the right to change these terms at any time. Continued use of WhenBald after changes constitutes your acceptance of the new terms. If any part of these terms is found invalid, the remaining terms shall remain in full force and effect.
          </p>
        </section>

        <div className="mt-16 bg-gradient-to-r from-primary-50 to-white p-8 rounded-2xl shadow-sm">
          <div className="text-center">
            <h2 className="text-2xl font-semibold mb-4">Ready to see your transformation?</h2>
            <p className="text-gray-600 mb-6">
              Try WhenBald now and get your personalized hair loss progression preview.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-primary-600 text-white px-8 py-4 rounded-xl hover:bg-primary-700 transition-all transform hover:scale-105 inline-flex items-center gap-2"
            >
              <User size={20} />
              Try WhenBald Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
